import { useOnboardingDraft } from '@/composables/useOnboardingDraft';
import { useOnboardingSession } from '@/composables/useOnboardingSession';
import { saveCurrentOnboardingState } from '@/services/onboarding.service';
import { sanitizeOnboardingDraft } from '@/services/onboarding.payload';

const ROUTE_BY_STEP = {
  0: 'onboarding:welcome',
  1: 'onboarding:company',
  2: 'onboarding:bank',
  3: 'onboarding:points',
  4: 'onboarding:tariff',
  5: 'onboarding:documents',
  6: 'onboarding:review',
  7: 'onboarding:success',
};

export function getOnboardingRouteName(currentStep) {
  return ROUTE_BY_STEP[Number(currentStep)] || ROUTE_BY_STEP[0];
}

export async function persistOnboardingRouteState(route) {
  const currentStep = Number(route.meta?.onboardingStep);
  if (!Number.isInteger(currentStep)) return null;

  const { session, hasSession, clearSession } = useOnboardingSession();
  if (!hasSession.value) return null;

  const { draft } = useOnboardingDraft();
  // Заявка уже отправлена (`complete`): черновик больше не меняется, PATCH не нужен.
  if (draft.value.submitted) return null;

  try {
    return await saveCurrentOnboardingState(
      {
        currentStep,
        // В PATCH уходит только allowlist-черновик: ни пароля, ни кода, ни токенов.
        draft: sanitizeOnboardingDraft(draft.value),
      },
      session.value.token,
    );
  } catch (error) {
    if (error?.status === 401) clearSession();
    throw error;
  }
}
